import { render, staticRenderFns } from "./Menuitem.vue?vue&type=template&id=7b49b805&scoped=true"
import script from "./Menuitem.vue?vue&type=script&lang=js"
export * from "./Menuitem.vue?vue&type=script&lang=js"
import style0 from "./Menuitem.vue?vue&type=style&index=0&id=7b49b805&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b49b805",
  null
  
)

export default component.exports